import { render, staticRenderFns } from "./k-api-rpanel.vue?vue&type=template&id=ae01342c&scoped=true"
import script from "./k-api-rpanel.vue?vue&type=script&lang=js"
export * from "./k-api-rpanel.vue?vue&type=script&lang=js"
import style0 from "./k-api-rpanel.vue?vue&type=style&index=0&id=ae01342c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae01342c",
  null
  
)

export default component.exports